import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { StyleSheet, css } from '../../utility/paypalAphrodite';
import colors from '../../styles/colors';
import fonts from '../../styles/fonts';

const buttonStyles = {
	amountBtn: {
		width: '86px',
		height: '48px',
		padding: 0,
		borderRadius: '5px',
		border: '1px solid #0070BA',
		fontSize: '16px',
		fontFamily: fonts.ppSansBigMedium,
		textDecoration: 'none',
		// Reduce width in xs screens to
		// fit 3 buttons in a row
		'@media (max-width: 340px)': {
			width: '78px'
		}
	},
	defaultColor: {
		backgroundColor: 'white',
		color: colors.primaryLightBlue,
		':hover': {
			color: colors.primaryBlue,
			borderColor: colors.primaryBlue,
			boxShadow: `0 0 0 1px ${colors.primaryBlue} inset`
		},
		':active': {
			color: colors.primaryBlue,
			borderColor: colors.primaryBlue,
			boxShadow: `0 0 0 1px ${colors.primaryBlue} inset`
		},
		':focus': {
			color: colors.primaryBlue,
			borderColor: colors.primaryBlue,
			boxShadow: `0 0 0 1px ${colors.primaryBlue} inset`
		}
	},
	highlightedColor: {
		backgroundColor: colors.primaryLightBlue,
		color: 'white'
	},
}

const STYLES = StyleSheet.create({
	defaultBtn: {
		...buttonStyles.amountBtn,
		...buttonStyles.defaultColor
	},
	highlightedBtn: {
		...buttonStyles.amountBtn,
		...buttonStyles.highlightedColor
	},
	currencyStyle: {
		fontFamily: fonts.ppSansSmallMedium,
		fontSize: 15,
	},
	currencyCodeStyle: {
		fontFamily: fonts.ppSansSmallRegular,
		fontSize: 11,
		marginTop: -4
	}
});

class PresetAmountButton extends React.Component {
	
	handleClick(event, value) {
		this.props.handleAmountBtnClick(event, this.props.value)
	}

	render() {
		const { selected } = this.props;
		const btnClasses = classNames(
			'vx_btn', {
				[css(STYLES.highlightedBtn)]: selected,
				[css(STYLES.defaultBtn)]: !selected,
			});

		return (
			<button type="button"
				className={btnClasses}
				onClick={this.handleClick.bind(this)}
			>
				<div className={css(STYLES.currencyStyle)}>{this.props.symbol}{this.props.value}</div>
				<div className={css(STYLES.currencyCodeStyle)}>USD</div>
			</button>
		);
	}
}

PresetAmountButton.propTypes = {
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	selected: PropTypes.bool,
	symbol: PropTypes.string,
	handleAmountBtnClick: PropTypes.func.isRequired
};

export default PresetAmountButton;



// WEBPACK FOOTER //
// ./components/amount/PresetAmountButton.js